/* eslint import/prefer-default-export: "off" */

export const getCustomPropertyValue = (propertyName) =>
  getComputedStyle(document.documentElement).getPropertyValue(propertyName);
